import { useState } from "react";
import { useSearchContext } from "../context/SearchContext";

export function PreferencePanel() {
  const { state, dispatch } = useSearchContext();
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between text-left text-sm font-medium text-slate-700"
      >
        <span>Travel preferences</span>
        <span className="text-slate-400">{open ? "Hide" : "Show"}</span>
      </button>

      {open && (
        <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
          <label className="flex flex-col gap-1 text-sm">
            <span className="text-slate-600">Hotel stars</span>
            <select
              value={state.preferences.hotel_stars}
              onChange={(e) =>
                dispatch({
                  type: "SET_PREFERENCES",
                  preferences: { hotel_stars: Number(e.target.value) },
                })
              }
              className="rounded border border-slate-300 px-3 py-2"
            >
              {[1, 2, 3, 4, 5].map((n) => (
                <option key={n} value={n}>
                  {n} stars
                </option>
              ))}
            </select>
          </label>

          <label className="flex flex-col gap-1 text-sm">
            <span className="text-slate-600">Max stops</span>
            <select
              value={state.preferences.max_stops}
              onChange={(e) =>
                dispatch({
                  type: "SET_PREFERENCES",
                  preferences: { max_stops: Number(e.target.value) },
                })
              }
              className="rounded border border-slate-300 px-3 py-2"
            >
              <option value={0}>Nonstop only</option>
              <option value={1}>1 stop</option>
              <option value={2}>2+ stops</option>
            </select>
          </label>

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={state.preferences.nonstop_only}
              onChange={(e) =>
                dispatch({
                  type: "SET_PREFERENCES",
                  preferences: { nonstop_only: e.target.checked },
                })
              }
            />
            Nonstop flights only
          </label>

          <label className="flex flex-col gap-1 text-sm">
            <span className="text-slate-600">Max budget (USD)</span>
            <input
              type="number"
              min={0}
              value={
                state.preferences.max_total_budget_cents
                  ? state.preferences.max_total_budget_cents / 100
                  : ""
              }
              onChange={(e) =>
                dispatch({
                  type: "SET_PREFERENCES",
                  preferences: {
                    max_total_budget_cents: e.target.value
                      ? Number(e.target.value) * 100
                      : undefined,
                  },
                })
              }
              className="rounded border border-slate-300 px-3 py-2"
              placeholder="No limit"
            />
          </label>
        </div>
      )}
    </div>
  );
}
